module.exports = __webpack_public_path__ + "img/oah-logo copy.f2df08e9.png";